export const REMINDER_MESSAGES = {
  DEFAULT: 'Quick reminder!',
  CONFIRMATION_TITLE: 'Tracking This',
  CONFIRMATION_MESSAGE_IN: (timeText: string) =>
    `Pique will check back in ${timeText}`,
  CONFIRMATION_MESSAGE_AT: (dateText: string) =>
    `Pique will check back ${dateText}`,
} as const;

export const REMINDER_TIME_OPTIONS = [
  {
    minutes: 60,
    label: '1h',
    displayText: '1 hour',
  },
  {
    minutes: 180,
    label: '3h',
    displayText: '3 hours',
  },
  {
    minutes: 1440,
    label: 'Tmrw',
    displayText: 'tomorrow',
  },
  {
    minutes: 10080,
    label: 'Next wk',
    displayText: 'next week',
  },
] as const;

export const REMINDER_TIME_OPTIONS_SHORT = REMINDER_TIME_OPTIONS.slice(1, 3);

export const getDisplayTextFromMinutes = (minutes: number): string => {
  const option = REMINDER_TIME_OPTIONS.find(opt => opt.minutes === minutes);
  if (option) return option.displayText;

  if (minutes < 60) return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  if (minutes < 1440) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (mins === 0) return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
    return `${hours}h ${mins}m`;
  }
  const days = Math.floor(minutes / 1440);
  return `${days} ${days === 1 ? 'day' : 'days'}`;
};

export const getDisplayTextFromDate = (date: Date): string => {
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const isTomorrow = date.toDateString() === tomorrow.toDateString();

  const timeStr = date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });

  if (isToday) return `today at ${timeStr}`;
  if (isTomorrow) return `tomorrow at ${timeStr}`;

  const dateStr = date.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
  return `${dateStr} at ${timeStr}`;
};

export const DEFAULT_REMINDER_MINUTES = 180;

export interface ReminderState {
  isSet: boolean;
  scheduledAt?: string;
  minutes?: number;
}
